// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tutorial-animation svg-icon {
  height: 30em;
}
tutorial-animation svg-icon svg {
  height: 100%;
  width: 100%;
  stroke: none;
}
tutorial-animation svg-icon svg g {
  opacity: 0;
}
tutorial-animation svg-icon.motes svg #introFlow_logo {
  animation: 0.5s ease-in-out fadeFromBottom forwards;
}
tutorial-animation svg-icon.user svg #introFlow_logo {
  animation: 0.2s ease-in-out fadeDown forwards;
}
tutorial-animation svg-icon.user svg #introFlow_blueDot {
  animation: 0.5s ease-in-out fadeFromBottom forwards;
}
tutorial-animation svg-icon.story svg #introFlow_blueDot {
  opacity: 1;
  animation: 0.5s bounceLeft forwards;
}
tutorial-animation svg-icon.story svg #introFlow_radius {
  transform-origin: center;
  animation: 0.5s 0.75s expand forwards;
}
tutorial-animation svg-icon.story svg #introFlow_whiteLock_1 {
  transform: translateX(15%);
  animation: 1s 0.25s fadeUp forwards;
}
tutorial-animation svg-icon.unlock svg #introFlow_blueDot, tutorial-animation svg-icon.unlock svg #introFlow_radius {
  opacity: 1;
  animation: 0.3s moveCenter;
}
tutorial-animation svg-icon.unlock svg #introFlow_whiteLock_1 {
  transform: translateX(15%);
  opacity: 1;
  animation: 0.3s ease-in-out 0.7s fadeDown forwards;
}
tutorial-animation svg-icon.unlock svg #introFlow_yellowLock {
  transform: translateX(15%);
  animation: 0.3s ease-in-out 0.7s fadeUp forwards;
}
tutorial-animation svg-icon.tours svg #introFlow_blueDot, tutorial-animation svg-icon.tours svg #introFlow_radius {
  animation: 0.8s exitLeft forwards;
}
tutorial-animation svg-icon.tours svg #introFlow_yellowLock {
  opacity: 1;
  animation: 0.5s moveYellowLock forwards;
}
tutorial-animation svg-icon.tours svg #introFlow_whiteLock_1 {
  animation: 1s moveWhiteLock1 0.7s forwards;
}
tutorial-animation svg-icon.tours svg #introFlow_whiteLock_2 {
  animation: 1s moveWhiteLock2 0.7s forwards;
}
tutorial-animation svg-icon.route svg #introFlow_yellowLock {
  opacity: 1;
  transform: translate(-10%, 10%);
}
tutorial-animation svg-icon.route svg #introFlow_whiteLock_1 {
  opacity: 1;
  transform: translate(-3%, -11%);
}
tutorial-animation svg-icon.route svg #introFlow_whiteLock_2 {
  opacity: 1;
  transform: translate(15%, -20%);
}
tutorial-animation svg-icon.route svg #introFlow_extendedLine1 {
  transform-origin: center;
  transform: translate(-6.5%, -0.5%) rotate(-5deg) scale(0.9);
  animation: 0.5s drawLine forwards;
}
tutorial-animation svg-icon.route svg #introFlow_extendedLine2 {
  transform-origin: center;
  transform: translate(6%, -15%) rotate(-17deg) scale(0.85);
  animation: 0.5s drawLine 1s forwards;
}
tutorial-animation svg-icon.collection svg #introFlow_yellowLock {
  opacity: 1;
  transform: translate(-10%, 17%);
  transition: transform 0.5s;
}
tutorial-animation svg-icon.collection svg #introFlow_whiteLock_1 {
  opacity: 1;
  transform: translate(-10%, -17%);
  transition: transform 0.5s;
}
tutorial-animation svg-icon.collection svg #introFlow_whiteLock_2 {
  opacity: 1;
  transform: translate(22%, 0%);
  transition: transform 0.5s;
}
tutorial-animation svg-icon.collection svg #introFlow_extendedLine1 {
  transform-origin: center;
  transform: translate(-6.5%, -0.5%) rotate(-5deg) scale(0.9);
  animation: 0.5s withdrawLine1 forwards;
}
tutorial-animation svg-icon.collection svg #introFlow_extendedLine2 {
  transform-origin: center;
  transform: translate(6%, -15%) rotate(-17deg) scale(0.8);
  animation: 0.5s withdrawLine2 forwards;
}
tutorial-animation svg-icon.browse svg #introFlow_yellowLock {
  opacity: 1;
  animation: 0.8s exitYellowLock forwards;
}
tutorial-animation svg-icon.browse svg #introFlow_whiteLock_1 {
  opacity: 1;
  animation: 0.8s exitWhiteLock1 forwards;
}
tutorial-animation svg-icon.browse svg #introFlow_whiteLock_2 {
  opacity: 1;
  animation: 0.8s exitWhiteLock2 forwards;
}
tutorial-animation svg-icon.browse svg #introFlow_loop, tutorial-animation svg-icon.browse svg #introFlow_loop g {
  animation: 0.3s fadingJump 0.4s forwards;
}
@keyframes fadingJump {
  0% {
    transform: translateY(5%);
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}
@keyframes exitYellowLock {
  0% {
    transform: translate(-10%, 17%);
  }
  50% {
    transform: translate(-7%, 17%);
  }
  100% {
    transform: translate(-100vw, 17%);
  }
}
@keyframes exitWhiteLock2 {
  0% {
    transform: translate(-10%, -17%);
  }
  50% {
    transform: translate(-7%, -17%);
  }
  100% {
    transform: translate(-100vw, -17%);
  }
}
@keyframes exitWhiteLock1 {
  0% {
    transform: translateX(22%);
  }
  50% {
    transform: translateX(19%);
  }
  100% {
    transform: translateX(100vw);
  }
}
@keyframes withdrawLine2 {
  0% {
    opacity: 1;
    stroke-dasharray: 70;
    stroke-dashoffset: 0;
  }
  100% {
    opacity: 0;
    stroke-dasharray: 70;
    stroke-dashoffset: 70;
  }
}
@keyframes withdrawLine1 {
  0% {
    opacity: 1;
    stroke-dasharray: 70;
    stroke-dashoffset: 0;
  }
  100% {
    opacity: 0;
    stroke-dasharray: 70;
    stroke-dashoffset: -70;
  }
}
@keyframes drawLine {
  0% {
    opacity: 1;
    stroke-dasharray: 70;
    stroke-dashoffset: 70;
  }
  100% {
    opacity: 1;
    stroke-dasharray: 70;
    stroke-dashoffset: 0;
  }
}
@keyframes moveWhiteLock2 {
  0% {
    opacity: 0;
    transform: translate(-10%, 10%);
  }
  100% {
    opacity: 1;
    transform: translate(15%, -20%);
  }
}
@keyframes moveWhiteLock1 {
  0% {
    opacity: 0;
    transform: translate(-10%, 10%);
  }
  100% {
    opacity: 1;
    transform: translate(-3%, -11%);
  }
}
@keyframes moveYellowLock {
  0% {
    transform: translateX(15%);
  }
  100% {
    transform: translate(-10%, 10%);
  }
}
@keyframes exitLeft {
  0% {
    opacity: 1;
    transform: translateX(0%);
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateX(-120vw);
    opacity: 0;
  }
}
@keyframes moveCenter {
  0% {
    transform: translateX(-20%);
  }
  100% {
    transform: translateX(0%);
  }
}
@keyframes expand {
  0% {
    opacity: 1;
    transform: translate(-20%, 0%) scale(0);
  }
  100% {
    opacity: 1;
    transform: translate(-20%, 0%) scale(1);
  }
}
@keyframes bounceLeft {
  0% {
    transform: translateX(0%);
  }
  50% {
    transform: translateX(3%);
  }
  100% {
    transform: translateX(-20%);
  }
}
@keyframes fadeUp {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeDown {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fadeFromBottom {
  0% {
    transform: translateY(50%);
    opacity: 0;
  }
  20% {
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/tutorial-animation/tutorial-animation.component.scss"],"names":[],"mappings":"AAEI;EACI,YAAA;AADR;AAGQ;EACI,YAAA;EACA,WAAA;EACA,YAAA;AADZ;AAGY;EACI,UAAA;AADhB;AAQQ;EACI,mDAAA;AANZ;AAYQ;EACI,6CAAA;AAVZ;AAaQ;EACI,mDAAA;AAXZ;AAiBQ;EACI,UAAA;EACA,mCAAA;AAfZ;AAkBQ;EACI,wBAAA;EACA,qCAAA;AAhBZ;AAmBQ;EACI,0BAAA;EACA,mCAAA;AAjBZ;AAuBQ;EACI,UAAA;EACA,0BAAA;AArBZ;AAwBQ;EACI,0BAAA;EACA,UAAA;EACA,kDAAA;AAtBZ;AAyBQ;EACI,0BAAA;EACA,gDAAA;AAvBZ;AA8BQ;EACI,iCAAA;AA5BZ;AA+BQ;EACI,UAAA;EACA,uCAAA;AA7BZ;AAgCQ;EACI,0CAAA;AA9BZ;AAiCQ;EACI,0CAAA;AA/BZ;AAqCQ;EACI,UAAA;EACA,+BAAA;AAnCZ;AAsCQ;EACI,UAAA;EACA,+BAAA;AApCZ;AAuCQ;EACI,UAAA;EACA,+BAAA;AArCZ;AAwCQ;EACI,wBAAA;EACA,2DAAA;EACA,iCAAA;AAtCZ;AAyCQ;EACI,wBAAA;EACA,yDAAA;EACA,oCAAA;AAvCZ;AA6CQ;EACI,UAAA;EACA,+BAAA;EACA,0BAAA;AA3CZ;AA8CQ;EACI,UAAA;EACA,gCAAA;EACA,0BAAA;AA5CZ;AA+CQ;EACI,UAAA;EACA,6BAAA;EACA,0BAAA;AA7CZ;AAgDQ;EACI,wBAAA;EACA,2DAAA;EACA,sCAAA;AA9CZ;AAiDQ;EACI,wBAAA;EACA,wDAAA;EACA,sCAAA;AA/CZ;AAqDQ;EACI,UAAA;EACA,uCAAA;AAnDZ;AAsDQ;EACI,UAAA;EACA,uCAAA;AApDZ;AAuDQ;EACI,UAAA;EACA,uCAAA;AArDZ;AAwDQ;EACI,wCAAA;AAtDZ;AA0DI;EACI;IACI,yBAAA;IACA,UAAA;EAxDV;EA0DM;IACI,yBAAA;IACA,UAAA;EAxDV;AACF;AA2DI;EACI;IACI,+BAAA;EAzDV;EA2DM;IACI,8BAAA;EAzDV;EA2DM;IACI,iCAAA;EAzDV;AACF;AA4DI;EACI;IACI,gCAAA;EA1DV;EA4DM;IACI,+BAAA;EA1DV;EA4DM;IACI,kCAAA;EA1DV;AACF;AA6DI;EACI;IACI,0BAAA;EA3DV;EA6DM;IACI,0BAAA;EA3DV;EA6DM;IACI,4BAAA;EA3DV;AACF;AA8DI;EACI;IACI,UAAA;IACA,oBAAA;IACA,oBAAA;EA5DV;EA+DM;IACI,UAAA;IACA,oBAAA;IACA,qBAAA;EA7DV;AACF;AAgEI;EACI;IACI,UAAA;IACA,oBAAA;IACA,oBAAA;EA9DV;EAiEM;IACI,UAAA;IACA,oBAAA;IACA,sBAAA;EA/DV;AACF;AAkEI;EACI;IACI,UAAA;IACA,oBAAA;IACA,qBAAA;EAhEV;EAkEM;IACI,UAAA;IACA,oBAAA;IACA,oBAAA;EAhEV;AACF;AAmEI;EACI;IACI,UAAA;IACA,+BAAA;EAjEV;EAmEM;IACI,UAAA;IACA,+BAAA;EAjEV;AACF;AAoEI;EACI;IACI,UAAA;IACA,+BAAA;EAlEV;EAoEM;IACI,UAAA;IACA,+BAAA;EAlEV;AACF;AAsEI;EACI;IACI,0BAAA;EApEV;EAsEM;IACI,+BAAA;EApEV;AACF;AAuEI;EACI;IACI,UAAA;IACA,yBAAA;EArEV;EAuEM;IACI,UAAA;EArEV;EAuEM;IACI,6BAAA;IACA,UAAA;EArEV;AACF;AAwEI;EACI;IACI,2BAAA;EAtEV;EAwEM;IACI,yBAAA;EAtEV;AACF;AAyEI;EACI;IACI,UAAA;IACA,uCAAA;EAvEV;EAyEM;IACI,UAAA;IACA,uCAAA;EAvEV;AACF;AA0EI;EACI;IACI,yBAAA;EAxEV;EA0EM;IACI,yBAAA;EAxEV;EA0EM;IACI,2BAAA;EAxEV;AACF;AA2EK;EACG;IACI,UAAA;EAzEV;EA2EM;IACI,UAAA;EAzEV;AACF;AA4EI;EACG;IACI,UAAA;EA1ET;EA4EK;IACI,UAAA;EA1ET;AACF;AA6EI;EACI;IACI,0BAAA;IACA,UAAA;EA3EV;EA6EM;IACI,UAAA;EA3EV;EA6EM;IACI,yBAAA;IACA,UAAA;EA3EV;AACF","sourcesContent":["tutorial-animation {\n\n    svg-icon { \n        height: 30em;\n\n        svg {\n            height: 100%;\n            width: 100%;\n            stroke: none;\n\n            g {\n                opacity: 0;\n            }\n        }\n    }\n\n    // Motes icon up\n    svg-icon.motes svg {\n        #introFlow_logo {\n            animation: 0.5s ease-in-out fadeFromBottom forwards;\n        }\n    }\n\n    // User up\n    svg-icon.user svg {\n        #introFlow_logo {\n            animation: 0.2s ease-in-out fadeDown forwards;\n        }\n\n        #introFlow_blueDot {\n            animation: 0.5s ease-in-out fadeFromBottom forwards;\n        }\n    }\n\n    // Story appears\n    svg-icon.story svg {\n        #introFlow_blueDot {\n            opacity: 1;\n            animation: 0.5s bounceLeft forwards\n        }\n\n        #introFlow_radius {\n            transform-origin: center;\n            animation: 0.5s 0.75s expand forwards;\n        }\n\n        #introFlow_whiteLock_1 {\n            transform: translateX(15%);\n            animation: 1s 0.25s fadeUp forwards;\n        }\n    }\n\n    // Story unlocks\n    svg-icon.unlock svg {\n        #introFlow_blueDot, #introFlow_radius {\n            opacity: 1;\n            animation: 0.3s moveCenter;\n        }\n\n        #introFlow_whiteLock_1 {\n            transform: translateX(15%);\n            opacity: 1;\n            animation: 0.3s ease-in-out 0.7s fadeDown forwards;\n        }\n\n        #introFlow_yellowLock {\n            transform: translateX(15%);\n            animation: 0.3s ease-in-out 0.7s fadeUp forwards;\n        }\n    \n    }\n\n    // Tour appears\n    svg-icon.tours svg {\n        #introFlow_blueDot, #introFlow_radius {\n            animation: 0.8s exitLeft forwards;\n        }\n\n        #introFlow_yellowLock {\n            opacity: 1;\n            animation: 0.5s moveYellowLock forwards;\n        }\n\n        #introFlow_whiteLock_1 {\n            animation: 1s moveWhiteLock1 0.7s forwards;\n        }\n\n        #introFlow_whiteLock_2 {\n            animation: 1s moveWhiteLock2 0.7s forwards;\n        }\n    }\n\n    // Route draws\n    svg-icon.route svg {\n        #introFlow_yellowLock {\n            opacity: 1;\n            transform: translate(-10%, 10%);\n        }\n\n        #introFlow_whiteLock_1 {\n            opacity: 1;\n            transform: translate(-3%, -11%);\n        }\n\n        #introFlow_whiteLock_2 {\n            opacity: 1;\n            transform: translate(15%, -20%);\n        }\n\n        #introFlow_extendedLine1 {\n            transform-origin: center;\n            transform: translate(-6.5%, -0.5%) rotate(-5deg) scale(0.9);\n            animation: 0.5s drawLine forwards;\n        }\n\n        #introFlow_extendedLine2 {\n            transform-origin: center;\n            transform: translate(6%, -15%) rotate(-17deg) scale(0.85);\n            animation: 0.5s drawLine 1s forwards;\n        }\n    }\n\n    // Collection appears\n    svg-icon.collection svg {\n        #introFlow_yellowLock {\n            opacity: 1;\n            transform: translate(-10%, 17%);\n            transition: transform 0.5s;\n        }\n\n        #introFlow_whiteLock_1 {\n            opacity: 1;\n            transform: translate(-10%, -17%);\n            transition: transform 0.5s;\n        }\n\n        #introFlow_whiteLock_2 {\n            opacity: 1;\n            transform: translate(22%, 0%);\n            transition: transform 0.5s;\n        }\n        \n        #introFlow_extendedLine1 {\n            transform-origin: center;\n            transform: translate(-6.5%, -0.5%) rotate(-5deg) scale(0.9);\n            animation: 0.5s withdrawLine1 forwards;\n        }\n\n        #introFlow_extendedLine2 {\n            transform-origin: center;\n            transform: translate(6%, -15%) rotate(-17deg) scale(0.8);\n            animation: 0.5s withdrawLine2 forwards;\n        }\n    }\n\n    // Magnifier up\n    svg-icon.browse svg {\n        #introFlow_yellowLock {\n            opacity: 1;\n            animation: 0.8s exitYellowLock forwards;\n        }\n        \n        #introFlow_whiteLock_1 {\n            opacity: 1;\n            animation: 0.8s exitWhiteLock1 forwards;\n        }\n\n        #introFlow_whiteLock_2 {\n            opacity: 1;\n            animation: 0.8s exitWhiteLock2 forwards;\n        }\n\n        #introFlow_loop, #introFlow_loop g {\n            animation: 0.3s fadingJump 0.4s forwards;\n        }\n    }\n\n    @keyframes fadingJump {\n        0% {\n            transform: translateY(5%);\n            opacity: 0;\n        }\n        100% {\n            transform: translateY(0%);\n            opacity: 1;\n        }\n    }\n    \n    @keyframes exitYellowLock {\n        0% {\n            transform: translate(-10%, 17%);\n        }\n        50% {\n            transform: translate(-7%, 17%);\n        }\n        100% {\n            transform: translate(-100vw, 17%);\n        }\n    }\n\n    @keyframes exitWhiteLock2 {\n        0% {\n            transform: translate(-10%, -17%);\n        }\n        50% {\n            transform: translate(-7%, -17%);\n        }\n        100% {\n            transform: translate(-100vw, -17%);\n        }\n    }\n\n    @keyframes exitWhiteLock1 {\n        0% {\n            transform: translateX(22%);\n        }\n        50% {\n            transform: translateX(19%);\n        }\n        100% {\n            transform: translateX(100vw);\n        }\n    }\n\n    @keyframes withdrawLine2 {\n        0% {\n            opacity: 1;\n            stroke-dasharray: 70;\n            stroke-dashoffset: 0;\n\n        }\n        100% {\n            opacity: 0;\n            stroke-dasharray: 70;\n            stroke-dashoffset: 70;\n        }\n    }\n\n    @keyframes withdrawLine1 {\n        0% {\n            opacity: 1;\n            stroke-dasharray: 70;\n            stroke-dashoffset: 0;\n\n        }\n        100% {\n            opacity: 0;\n            stroke-dasharray: 70;\n            stroke-dashoffset: -70;\n        }\n    }\n\n    @keyframes drawLine {\n        0% {\n            opacity: 1;\n            stroke-dasharray: 70;\n            stroke-dashoffset: 70;\n        }\n        100% {\n            opacity: 1;\n            stroke-dasharray: 70;\n            stroke-dashoffset: 0;\n        }\n    }\n\n    @keyframes moveWhiteLock2 {\n        0% {\n            opacity: 0;\n            transform: translate(-10%, 10%);\n        }\n        100% {\n            opacity: 1;\n            transform: translate(15%, -20%);\n        }\n    }\n\n    @keyframes moveWhiteLock1 {\n        0% {\n            opacity: 0;\n            transform: translate(-10%, 10%);\n        }\n        100% {\n            opacity: 1;\n            transform: translate(-3%, -11%);\n        }\n        \n    }\n\n    @keyframes moveYellowLock {\n        0% {\n            transform: translateX(15%);\n        }\n        100% {\n            transform: translate(-10%, 10%);\n        }\n    }\n\n    @keyframes exitLeft {\n        0% {\n            opacity: 1;\n            transform: translateX(0%);\n        }\n        90% {\n            opacity: 1;\n        }\n        100% {\n            transform: translateX(-120vw);\n            opacity: 0;\n        }\n    }\n\n    @keyframes moveCenter {\n        0% {\n            transform: translateX(-20%);\n        }\n        100% {\n            transform: translateX(-0%);\n        }\n    }\n\n    @keyframes expand {\n        0% {\n            opacity: 1;\n            transform: translate(-20%, 0%) scale(0);\n        }\n        100% {\n            opacity: 1;\n            transform: translate(-20%, 0%) scale(1);\n        }\n    }\n\n    @keyframes bounceLeft {\n        0% {\n            transform: translateX(0%);\n        }\n        50% {\n            transform: translateX(3%);\n        }\n        100% {\n            transform: translateX(-20%);\n        }\n    }\n\n     @keyframes fadeUp {\n        0% {\n            opacity: 0;\n        }\n        100% {\n            opacity: 1;\n        }\n    }\n\n    @keyframes fadeDown {\n       0% {\n           opacity: 1;\n       }\n       100% {\n           opacity: 0;\n       }\n    }\n    \n    @keyframes fadeFromBottom {\n        0% {\n            transform: translateY(50%);\n            opacity: 0;\n        }\n        20% {\n            opacity: 0;\n        }\n        100% {\n            transform: translateY(0%);\n            opacity: 1;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
